var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 104,
    viewBox: "0 0 103 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 102.081H1.5M1.5 44.1858L21.815 27.0806M101.5 44.1858L60.87 9.9753C58.2104 7.73578 54.9059 6.5157 51.5 6.5157C48.0941 6.5157 44.7896 7.73578 42.13 9.9753L38.22 13.2648M69 15.2385V4.71215C69 4.01421 69.2634 3.34486 69.7322 2.85134C70.2011 2.35782 70.837 2.08057 71.5 2.08057H84C84.663 2.08057 85.2989 2.35782 85.7678 2.85134C86.2366 3.34486 86.5 4.01421 86.5 4.71215V31.0279M11.5 102.081V36.2911M91.5 36.2911V57.3437M91.5 102.081V78.3964",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 102.081V75.7648C66.5 68.3227 66.5 64.6016 64.3 62.2911C62.11 59.9753 58.575 59.9753 51.5 59.9753C44.425 59.9753 40.895 59.9753 38.7 62.2911M36.5 102.081V75.7648",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 36.2911C61.5 39.0828 60.4464 41.7603 58.5711 43.7343C56.6957 45.7084 54.1522 46.8174 51.5 46.8174C48.8478 46.8174 46.3043 45.7084 44.4289 43.7343C42.5536 41.7603 41.5 39.0828 41.5 36.2911C41.5 33.4993 42.5536 30.8219 44.4289 28.8479C46.3043 26.8738 48.8478 25.7648 51.5 25.7648C54.1522 25.7648 56.6957 26.8738 58.5711 28.8479C60.4464 30.8219 61.5 33.4993 61.5 36.2911Z",
    stroke: "currentColor",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/properties.a1fd4cb9668d4480b89067f86052e738.svg";
export { ForwardRef as ReactComponent };